import React from 'react';
import i18n from "i18next";
import { withTranslation } from 'react-i18next';

const PageHeader = props => {
    const header = "page_headers." + props.text;
    const headerCustom = props.textCustom;
    const personalized = " van " + props.personalized;

    //SbC never render a raw i18n key. Some titles are built from async state
    //(e.g. "books_new_" + view), so the key is briefly missing on first paint;
    //i18next would echo the key as text. Render nothing until it resolves.
    const hasHeader = i18n.exists(header);
    const hasSubtitle = props.subtitle && i18n.exists(props.subtitle);

    return (
        <div className="content-segment">
            <div className="content-segment__header">
                {(props.personalized && props.personalized !== '')
                    ?   <React.Fragment>
                            {hasHeader &&
                                <h1>
                                    {i18n.t(header, {from_person: personalized})}
                                </h1>
                            }
                            {hasSubtitle &&
                                <span
                                    classsName="content-segment__header-subtitle"
                                    dangerouslySetInnerHTML={{ __html: i18n.t(props.subtitle)}}
                                />
                            }
                        </React.Fragment>
                    :   <React.Fragment>
                            {headerCustom && headerCustom !== ''
                            ?   <h1>{headerCustom}</h1>
                            :   hasHeader &&
                                <h1
                                    dangerouslySetInnerHTML={{ __html: i18n.t(header)}}
                                />

                            }
                            {hasSubtitle &&
                                <span
                                    classsName="content-segment__header-subtitle"
                                    dangerouslySetInnerHTML={{ __html: i18n.t(props.subtitle)}}
                                />
                            }
                        </React.Fragment>
                }
            </div>
        </div>
    );
}

export default withTranslation()(PageHeader);